<div class="app">
  <app-header></app-header>

  <main class="app__main">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
</div>

